__turbopack_context__.v({
  "action": "HintLayer-module__7TIxqq__action",
  "close": "HintLayer-module__7TIxqq__close",
  "head": "HintLayer-module__7TIxqq__head",
  "hint": "HintLayer-module__7TIxqq__hint",
  "hint-in": "HintLayer-module__7TIxqq__hint-in",
  "region": "HintLayer-module__7TIxqq__region",
  "still": "HintLayer-module__7TIxqq__still",
  "text": "HintLayer-module__7TIxqq__text",
});
